import { UpmindObjectTypes } from "./objects";

export enum DelegateObjectTypes {
  CLIENT = UpmindObjectTypes.CLIENT,
  CONTRACT_PRODUCT = UpmindObjectTypes.CONTRACTS_PRODUCT,
  TICKET = UpmindObjectTypes.TICKET,
}

export enum DelegateCreatorObjectTypes {
  BRAND = "brand",
  CLIENT = "client",
  USER = "user",
}
